export default __webpack_public_path__ + "static/bg-41d98dc5ff1c3d38987a38087c17fbe2.jpg";